import { Box, Button, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const QuickActions = () => {
    const navigate = useNavigate();

    return (
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mt: 1 }}>
            <Tooltip title="Criar novo especialista">
                <Button
                    variant="outlined"
                    endIcon={
                        <Box
                            component="img"
                            src="/assets/logos-svg/addDoctor.svg"
                            alt="Adicionar especialista"
                            sx={{ width: 22, height: 22 }}
                        />
                    }
                    onClick={() => navigate('/doctors/new')}
                    sx={{
                        minHeight: 64,
                        px: 2.6,
                        py: 1.7,
                        textTransform: 'none',
                        fontSize: '0.95rem',
                        fontWeight: 700,
                        color: '#3D3D3D',
                        borderColor: '#D9D9D9',
                        borderWidth: '2px',
                        bgcolor: '#FFFFFF',
                        borderRadius: '18px',
                        boxShadow: '0px 2px 8px rgba(61, 61, 61, 0.06)',
                        '& .MuiButton-endIcon': {
                            ml: 1.2
                        },
                        '&:hover': {
                            bgcolor: '#F7F7F7',
                            borderColor: '#CFCFCF',
                            borderWidth: '2px'
                        }
                    }}
                >
                    Adicionar Especialista
                </Button>
            </Tooltip>
            <Tooltip title="Criar novo cuidador e paciente">
                <Button
                    variant="outlined"
                    endIcon={
                        <Box
                            component="img"
                            src="/assets/logos-svg/addCaregiver.svg"
                            alt="Adicionar cuidador e paciente"
                            sx={{ width: 22, height: 22 }}
                        />
                    }
                    onClick={() => navigate('/caregivers/new')}
                    sx={{
                        minHeight: 64,
                        px: 2.6,
                        py: 1.7,
                        textTransform: 'none',
                        fontSize: '0.95rem',
                        fontWeight: 700,
                        color: '#3D3D3D',
                        borderColor: '#D9D9D9',
                        borderWidth: '2px',
                        bgcolor: '#FFFFFF',
                        borderRadius: '18px',
                        boxShadow: '0px 2px 8px rgba(61, 61, 61, 0.06)',
                        '& .MuiButton-endIcon': {
                            ml: 1.2
                        },
                        '&:hover': {
                            bgcolor: '#F7F7F7',
                            borderColor: '#CFCFCF',
                            borderWidth: '2px'
                        }
                    }}
                >
                    Adicionar Cuidador e Paciente
                </Button>
            </Tooltip>
        </Box>
    );
};

export default QuickActions;
